import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';

const STATUS_STYLES = {
  DRAFT: 'bg-gray-100 text-gray-700',
  SENT: 'bg-blue-100 text-blue-700',
  ACCEPTED: 'bg-green-100 text-green-700',
  DECLINED: 'bg-red-100 text-red-700',
};

export default function Estimates() {
  const [estimates, setEstimates] = useState([]);

  useEffect(() => {
    api('/estimates').then(r => r.ok ? r.json() : []).then(setEstimates);
  }, []);

  return (
    <Layout>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Estimates</h2>
        <Link to="/estimates/new" className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700">
          New Estimate
        </Link>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">#</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Title</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Customer</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Total</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {estimates.map(est => (
              <tr key={est.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-sm text-gray-500">{est.estimateNumber}</td>
                <td className="px-6 py-4">
                  <Link to={`/estimates/${est.id}`} className="text-yellow-600 hover:text-yellow-800 font-medium">{est.title}</Link>
                </td>
                <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{est.companyName || est.contactName || '—'}</td>
                <td className="px-6 py-4 text-gray-900 font-medium hidden sm:table-cell">${est.total?.toFixed(2)}</td>
                <td className="px-6 py-4">
                  <span className={`inline-flex px-2 py-1 rounded text-xs font-medium ${STATUS_STYLES[est.status] || ''}`}>{est.status}</span>
                </td>
                <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{est.createdAt ? new Date(est.createdAt).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {estimates.length === 0 && <div className="text-center py-12 text-gray-500">No estimates yet. Create one to get started.</div>}
      </div>
    </Layout>
  );
}
